import type { SendWhatsAppDTO, SendWhatsAppOptions } from '../types';
import type { WhatsAppProvider } from '../types';
import { buildMetaPayload } from './meta.strategy';
import { buildTwilioPayload } from './twilio.strategy';
import { API_TWILIO, API_WSP } from 'src/constants/conversations';

function resolveProvider(dto: SendWhatsAppDTO): WhatsAppProvider {
    if (dto.provider === API_WSP || dto.provider === 'meta') return API_WSP;
    if (dto.provider === API_TWILIO) return API_TWILIO;
    return API_TWILIO;
}

/**
 * Sends a WhatsApp message or template.
 * Strategy (Meta/WSP vs Twilio) is chosen by dto.provider when provided by the caller
 * (e.g. from store.areas / getAreaData(area, store.areas).api or formatMessageToSend sendType).
 * Otherwise falls back to env.
 *
 * @param dto - Primitive payload; provider can be set from store/area config (twilio | wsp)
 * @param options - transport and endpoint (provided by the calling module)
 * @returns Response from transport.post
 */
export async function sendWhatsApp(
    dto: SendWhatsAppDTO,
    options: SendWhatsAppOptions
): Promise<{ data?: unknown }> {
    const { transport, endpoint, config } = options;
    const provider = resolveProvider(dto);

    const payload =
        provider === API_WSP || provider === 'meta'
            ? buildMetaPayload(dto)
            : buildTwilioPayload(dto);

    return transport.post(endpoint, payload, config);
}
